module.exports = __webpack_public_path__ + "static/media/white_red4.8e58cc79.jpg";